import { render, staticRenderFns } from "./StyleguideModalSmall.vue?vue&type=template&id=5a28e2fe&"
import script from "./StyleguideModalSmall.vue?vue&type=script&lang=js&"
export * from "./StyleguideModalSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports